export default "__VITE_ASSET__BovzE1o5__"